import React from 'react';
import { TemplateProps } from '../../../types/cv';
import { isSectionContinuation } from '../../../utils/cvPagination';
import './RedNavyTemplate.css';

const SHAPE_BASE = "M -13.8 148.5 c 0.0 162.4 0.0 162.4 56.4 162.4 56.4 -0.0 56.4 -0.0 56.4 -7.9 0.0 -7.9 0.0 -7.9 0.3 -9.2 0.3 -2.0 1.0 -6.6 1.1 -7.9 0.1 -0.6 0.2 -2.0 0.4 -3.0 0.2 -1.4 0.3 -2.4 0.3 -3.9 0.0 -1.2 0.1 -2.6 0.2 -3.3 0.2 -1.5 0.2 -16.5 -0.0 -17.3 -0.1 -0.3 -0.1 -1.2 -0.2 -2.0 -0.0 -0.8 -0.2 -2.4 -0.3 -3.5 -0.1 -1.1 -0.3 -2.5 -0.4 -3.1 -0.1 -0.5 -0.2 -1.7 -0.3 -2.6 -0.1 -0.9 -0.3 -2.0 -0.3 -2.5 -0.1 -1.1 -0.6 -3.6 -1.0 -5.1 -0.1 -0.5 -0.4 -1.7 -0.5 -2.6 -0.2 -0.9 -0.5 -2.6 -0.9 -3.9 -1.0 -3.9 -1.2 -4.6 -3.2 -10.7 -0.6 -1.8 -1.9 -5.5 -2.6 -7.0 -0.2 -0.6 -0.7 -1.6 -1.0 -2.3 -2.6 -6.3 -6.8 -14.3 -9.8 -18.7 -0.4 -0.6 -1.0 -1.6 -1.4 -2.2 -0.4 -0.6 -1.1 -1.7 -1.5 -2.3 -0.5 -0.7 -1.3 -1.8 -1.8 -2.6 -0.5 -0.8 -1.3 -1.8 -1.8 -2.4 -0.5 -0.6 -1.3 -1.6 -1.8 -2.3 -1.5 -1.9 -4.0 -5.0 -5.3 -6.3 -0.5 -0.5 -1.2 -1.3 -1.5 -1.7 -0.8 -0.9 -3.6 -3.7 -4.6 -4.6 -0.4 -0.3 -1.1 -1.0 -1.6 -1.5 -0.5 -0.5 -1.4 -1.3 -1.9 -1.7 -2.6 -2.3 -3.5 -4.0 -5.5 -10.9 -0.2 -0.8 -0.4 -63.1 -0.2 -64.3 0.1 -0.7 0.7 -2.4 1.4 -4.2 1.2 -3.1 1.3 -3.2 4.6 -3.7 4.5 -0.7 9.4 -2.1 13.1 -3.7 0.7 -0.3 1.8 -0.7 2.4 -1.0 2.0 -0.8 6.7 -3.4 9.5 -5.1 9.7 -6.2 17.9 -14.6 24.0 -24.7 0.5 -0.8 1.1 -1.8 1.4 -2.3 0.5 -0.8 2.4 -4.4 2.9 -5.5 1.5 -3.5 2.2 -12.8 1.4 -18.4 -0.2 -1.2 -0.3 -2.4 -0.4 -2.7 -0.1 -1.3 -0.4 -2.3 -1.0 -4.1 -0.2 -0.7 -0.5 -1.7 -0.7 -2.3 -0.9 -3.0 -4.0 -9.0 -6.6 -12.5 -1.1 -1.5 -1.1 -1.4 -1.1 -9.1 0.0 -6.3 0.0 -6.3 -58.3 -6.3 -58.3 -0.0 -58.3 -0.0 -58.3 162.4 z";
const SHAPE_RED = "M 99.0 -6.3 c 0.0 7.7 0.0 7.7 0.4 9.4 0.4 1.7 1.2 7.2 1.3 8.5 0.0 0.4 0.1 1.4 0.2 2.3 0.2 2.1 0.2 10.7 -0.0 12.5 -0.1 0.6 -0.2 1.5 -0.2 2.1 -0.9 10.1 -6.2 23.0 -10.1 24.3 -2.2 0.8 -6.4 1.4 -9.9 1.5 -4.4 0.1 -4.1 -0.1 -8.3 5.8 -0.5 0.6 -1.1 1.5 -1.4 1.9 -0.9 1.1 -1.9 2.5 -2.7 3.7 -0.4 0.6 -1.1 1.6 -1.6 2.2 -0.5 0.6 -1.3 1.8 -1.9 2.6 -0.6 0.8 -1.4 2.0 -1.9 2.6 -0.5 0.6 -1.8 2.3 -2.8 3.7 -1.0 1.4 -2.3 3.0 -2.7 3.6 -2.8 3.7 -1.5 4.1 5.9 2.3 2.7 -0.7 5.6 -1.6 7.7 -2.5 0.7 -0.3 1.8 -0.7 2.4 -1.0 2.0 -0.8 6.7 -3.4 9.5 -5.1 9.7 -6.2 17.9 -14.6 24.0 -24.7 0.5 -0.8 1.1 -1.8 1.4 -2.3 0.5 -0.8 2.4 -4.4 2.9 -5.5 1.5 -3.5 2.2 -12.8 1.4 -18.4 -0.2 -1.2 -0.3 -2.4 -0.4 -2.7 -0.1 -1.3 -0.4 -2.3 -1.0 -4.1 -0.2 -0.7 -0.5 -1.7 -0.7 -2.3 -0.9 -3.0 -4.0 -9.0 -6.6 -12.5 -1.1 -1.5 -1.1 -1.4 -1.1 -9.1 0.0 -6.3 0.0 -6.3 -1.9 -6.3 -1.9 -0.0 -1.9 -0.0 -1.9 7.6 z M 55.2 166.2 c -0.4 0.2 -0.8 0.6 -2.1 2.4 -7.0 9.3 -20.4 17.0 -33.1 19.0 -0.6 0.1 -1.5 0.3 -2.1 0.4 -0.5 0.1 -1.4 0.3 -1.9 0.3 -0.5 0.1 -1.6 0.2 -2.3 0.4 -0.9 0.1 -1.9 0.2 -3.3 0.3 -1.1 0.0 -2.4 0.1 -2.9 0.2 -0.8 0.1 -2.4 0.1 -11.1 0.2 -10.2 0.0 -10.2 0.0 -10.2 1.0 0.0 1.0 0.0 1.0 7.2 1.0 7.8 -0.0 7.5 -0.0 9.9 0.5 6.0 1.4 15.3 2.8 19.2 3.0 0.7 0.0 1.7 0.1 2.2 0.2 1.4 0.2 13.2 0.2 14.7 -0.0 0.6 -0.1 1.4 -0.2 1.9 -0.2 4.2 -0.3 14.4 -2.4 18.1 -3.7 2.9 -1.1 3.7 -1.4 5.0 -2.0 4.7 -2.2 4.7 -2.2 6.6 3.9 0.5 1.5 1.0 3.2 1.3 4.6 0.3 1.2 0.6 2.6 0.7 3.2 0.6 2.5 1.6 8.6 1.8 10.8 0.0 0.4 0.1 1.2 0.2 1.8 0.1 0.5 0.1 1.5 0.2 2.0 0.0 0.5 0.1 1.5 0.2 2.2 0.2 1.7 0.2 12.4 0.0 14.1 -0.1 0.6 -0.2 1.9 -0.2 2.9 -0.0 1.0 -0.1 2.2 -0.2 2.7 -0.1 0.5 -0.1 1.4 -0.2 1.8 -0.0 0.4 -0.2 1.5 -0.3 2.4 -0.1 0.9 -0.3 2.2 -0.4 2.9 -0.2 1.9 -0.5 3.8 -0.9 6.2 -0.2 1.2 -0.6 3.0 -0.8 4.0 -0.4 2.3 -1.3 6.2 -1.6 7.5 -0.1 0.5 -0.4 1.5 -0.6 2.2 -0.6 2.5 -2.9 10.4 -4.1 14.2 -0.3 0.9 -0.7 2.2 -1.0 2.9 -0.2 0.8 -0.7 2.2 -1.1 3.1 -0.4 1.0 -0.8 2.1 -0.9 2.4 -0.2 0.7 -1.3 3.6 -2.0 5.4 -1.6 3.9 -1.5 3.2 -1.6 11.6 -0.0 7.1 -0.0 7.1 19.7 7.1 19.8 -0.0 19.8 -0.0 19.8 -7.9 0.0 -7.9 0.0 -7.9 0.3 -9.2 0.3 -2.0 1.0 -6.6 1.1 -7.9 0.1 -0.6 0.2 -2.0 0.4 -3.0 0.2 -1.4 0.3 -2.4 0.3 -3.9 0.0 -1.2 0.1 -2.6 0.2 -3.3 0.2 -1.5 0.2 -16.5 -0.0 -17.3 -0.1 -0.3 -0.1 -1.2 -0.2 -2.0 -0.0 -0.8 -0.2 -2.4 -0.3 -3.5 -0.1 -1.1 -0.3 -2.5 -0.4 -3.1 -0.1 -0.5 -0.2 -1.7 -0.3 -2.6 -0.1 -0.9 -0.3 -2.0 -0.3 -2.5 -0.1 -1.1 -0.6 -3.6 -1.0 -5.1 -0.1 -0.5 -0.4 -1.7 -0.5 -2.6 -0.2 -0.9 -0.5 -2.6 -0.9 -3.9 -1.0 -3.9 -1.2 -4.6 -3.2 -10.7 -0.6 -1.8 -1.9 -5.5 -2.6 -7.0 -0.2 -0.6 -0.7 -1.6 -1.0 -2.3 -2.6 -6.3 -6.8 -14.3 -9.8 -18.7 -0.4 -0.6 -1.0 -1.6 -1.4 -2.2 -0.4 -0.6 -1.1 -1.7 -1.5 -2.3 -0.5 -0.7 -1.3 -1.8 -1.8 -2.6 -0.5 -0.8 -1.3 -1.8 -1.8 -2.4 -0.5 -0.6 -1.3 -1.6 -1.8 -2.3 -1.5 -1.9 -4.0 -5.0 -5.3 -6.3 -0.5 -0.5 -1.2 -1.3 -1.5 -1.7 -0.8 -0.9 -3.6 -3.7 -4.6 -4.6 -0.4 -0.3 -1.1 -1.0 -1.7 -1.6 -2.3 -2.2 -3.3 -2.7 -4.1 -2.3 z";
const RIBBON_BAND = "-2,93.07 63.66,99.70 63.66,141.88 -2,148.50";
const RIBBON_FOLD = "63.66,99.70 70.92,105.62 70.92,136.65 63.66,141.88";
const RIBBON_ARROW = "70.92,105.28 75.77,105.28 102.41,120.96 75.77,136.65 70.92,136.65";
const RIBBON_TAIL = "-2,148.50 63.66,141.88 -2,153.38";

type IconProps = { className?: string };

const filled = (children: React.ReactNode, p: IconProps = {}) => (
    <svg className={p.className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
        {children}
    </svg>
);

const IconPhone = (p?: IconProps) =>
    filled(
        <>
            <path d="M6.7 2.4 3.3 3.8a2 2 0 0 0-1.2 2.3A18.2 18.2 0 0 0 15.9 20a2 2 0 0 0 2.3-1.2l1.4-3.4-4.4-2.4-2 2a13.4 13.4 0 0 1-5.9-5.9l2-2z" />
            <path d="M14.6 2.5a1 1 0 0 0-.3 2 5.2 5.2 0 0 1 4.1 4.2 1 1 0 0 0 2-.3 7.2 7.2 0 0 0-5.8-5.9zM14.2 6a1 1 0 0 0-.4 2 2 2 0 0 1 1.5 1.6 1 1 0 0 0 2-.4A4 4 0 0 0 14.2 6z" />
        </>,
        p
    );

const IconMail = (p?: IconProps) =>
    filled(
        <>
            <path d="M2 5.4h20v1.1L12 13.2 2 6.5z" />
            <path d="M2 8.6 12 15.3 22 8.6V18.6H2z" />
        </>,
        p
    );

const IconMonitor = (p?: IconProps) =>
    filled(
        <>
            <rect x="2" y="4" width="20" height="12.6" rx="1.4" />
            <rect x="8.4" y="18.2" width="7.2" height="1.8" rx=".9" />
        </>,
        p
    );

const IconHome = (p?: IconProps) =>
    filled(<path d="M12 2.8 1.6 11.5h2.9V21h5.2v-5.8h4.6V21h5.2v-9.5h2.9z" />, p);

const IconPerson = (p?: IconProps) =>
    filled(
        <>
            <circle cx="12" cy="8.2" r="3.7" />
            <path d="M4.4 20.4a7.6 7.6 0 0 1 15.2 0z" />
        </>,
        p
    );

const IconCap = (p?: IconProps) =>
    filled(
        <>
            <path d="M12 3 1 8.6l11 5.5 8.6-4.3v5.4h1.6V8.6z" />
            <path d="M5.6 12.1v4.3c0 2 2.9 3.7 6.4 3.7s6.4-1.7 6.4-3.7v-4.3L12 15.4z" />
        </>,
        p
    );

const IconBriefcase = (p?: IconProps) =>
    filled(
        <>
            <path d="M9.4 3.4h5.2a2.2 2.2 0 0 1 2.2 2.2v1.6h-2V5.4H9.2v1.8h-2V5.6a2.2 2.2 0 0 1 2.2-2.2z" />
            <path d="M2 8.4h20v3.9l-8.6 2.1v-1.5h-2.8v1.5L2 12.3z" />
            <path d="M2 14.1l8.6 2.1v1.4h2.8v-1.4L22 14.1v6.5H2z" />
        </>,
        p
    );

const Marker = () => (
    <svg className="cv2-marker" viewBox="0 0 10 10" aria-hidden="true" focusable="false">
        <path d="M1.4 0.5 8.7 5 1.4 9.5z" fill="currentColor" />
    </svg>
);

const Background = () => (
    <svg className="cv2-bg" viewBox="0 0 210 297" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path fill="var(--cv2-navy)" d={SHAPE_BASE} />
        <path fill="var(--cv2-red)" d={SHAPE_RED} />
        <polygon fill="#B9202F" points={RIBBON_TAIL} />
        <polygon fill="#C62032" points={RIBBON_FOLD} />
        <polygon fill="var(--cv2-red)" points={RIBBON_BAND} />
        <polygon fill="var(--cv2-red)" points={RIBBON_ARROW} />
    </svg>
);

const extractYear = (date: string): string => {
    const m = String(date || '').match(/(19|20)\d{2}/);
    return m ? m[0] : (date || '').slice(0, 4) || '';
};

const formatPeriod = (start: string, end: string, isCurrent?: boolean) => {
    const a = extractYear(start);
    const b = isCurrent ? 'Present' : extractYear(end);
    if (a && b) return `${a}-${b}`;
    return a || b || '—';
};

type Entry = { period: string; organization: string; description: string };

const Entries: React.FC<{ items: Entry[] }> = ({ items }) => (
    <div className="cv2-entries">
        {items.map((item, i) => (
            <div className="cv2-entry" key={i}>
                <Marker />
                <div>
                    <h3>
                        {item.period}
                        <span>{item.organization}</span>
                    </h3>
                    {item.description ? <p>{item.description}</p> : null}
                </div>
            </div>
        ))}
    </div>
);

const RedNavyTemplate: React.FC<TemplateProps> = ({
    data,
    isContinuationPage = false,
    showPlaceholders = false,
    pageIndex = 0,
    fullData,
}) => {
    const primaryColor = data.style?.primaryColor || '#E52232';
    const navy = data.style?.sectionBackgroundColor || data.style?.secondaryColor || '#141726';
    const { fontFamily = '' } = data.style || {};

    const source = fullData || data;
    const eduContinued = isSectionContinuation(source, 'education', pageIndex);
    const expContinued = isSectionContinuation(source, 'experience', pageIndex);

    const firstName = data.personalInfo.firstName || (showPlaceholders ? 'JAME' : '');
    const lastName = data.personalInfo.lastName || (showPlaceholders ? 'SMITH' : '');
    const fullName = `${firstName} ${lastName}`.trim().toUpperCase();
    const jobTitle = data.personalInfo.profession || (showPlaceholders ? 'Marketing Business' : '');
    const photoUrl = data.personalInfo.profileImage || '';

    const phone = data.personalInfo.phone || (showPlaceholders ? '+2 434-232-534234' : '');
    const email = data.personalInfo.email || (showPlaceholders ? 'sarawalton@mail.com' : '');
    const website = data.personalInfo.website || (showPlaceholders ? 'sarawalton.com' : '');
    const address = data.personalInfo.address || (showPlaceholders ? 'Main street # 32' : '');

    const profile =
        data.personalInfo.summary ||
        (showPlaceholders
            ? 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer euismod diam sed diam aliquet magna scelerisque. Sed non posuere risus. Duis sit amet a mauris ac leo luctus fermentum. Fusce in luctus the metus.'
            : '');

    const sideProfile =
        profile ||
        (showPlaceholders
            ? 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus aliquam orci a ex molestie, eu ornare odio scelerisque. Nam eu metus fringilla, vulputate metus in, consequat nunc.'
            : '');

    const education: Entry[] =
        data.education.length > 0
            ? data.education.map((edu) => ({
                  period: formatPeriod(edu.startDate, edu.endDate, edu.isCurrent),
                  organization: edu.institution || edu.degree || 'University',
                  description:
                      edu.description ||
                      [edu.degree, edu.field].filter(Boolean).join(' — '),
              }))
            : showPlaceholders
              ? [
                    {
                        period: '2007-2010',
                        organization: 'University Name',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer euismod diam.',
                    },
                    {
                        period: '2011-2015',
                        organization: 'University Name',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer euismod diam sed diam.',
                    },
                    {
                        period: '2016-2020',
                        organization: 'University Name',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer euismod diam sed diam aliquet scelerisque. Sed non posuere risus.',
                    },
                ]
              : [];

    const experience: Entry[] =
        data.experience.length > 0
            ? data.experience.map((exp) => ({
                  period: formatPeriod(exp.startDate, exp.endDate, exp.isCurrent),
                  organization: exp.company || exp.position || 'Company',
                  description: exp.description || exp.position || '',
              }))
            : showPlaceholders
              ? [
                    {
                        period: '2012-2017',
                        organization: 'Company Name 01',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer euismod diam.',
                    },
                    {
                        period: '2018-2021',
                        organization: 'Company Name 02',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer euismod diam sed diam aliquet scelerisque. Sed non posuere risus.',
                    },
                ]
              : [];

    const contactRows: Array<{ icon: React.ReactNode; value: string }> = [
        { icon: <IconPhone />, value: phone },
        { icon: <IconMail />, value: email },
        { icon: <IconMonitor />, value: website },
        { icon: <IconHome />, value: address },
    ].filter((r) => r.value);

    const cssVars = {
        ['--cv2-red' as string]: primaryColor,
        ['--cv2-navy' as string]: navy,
    } as React.CSSProperties;

    return (
        <article
            className={`shadow-2xl cv-page-sheet cv2-page${isContinuationPage ? ' cv2-continued' : ''} ${fontFamily}`.trim()}
            style={cssVars}
        >
            <Background />

            {isContinuationPage && (
                <p className="cv2-continued-label cv-fs-name">
                    {fullName} — Suite
                </p>
            )}

            {!isContinuationPage && (
                <>
                    <div className="cv2-photo">
                        {photoUrl ? (
                            <img src={photoUrl} alt={fullName} />
                        ) : (
                            <span className="cv2-photo__placeholder">
                                <IconPerson />
                            </span>
                        )}
                    </div>

                    <header className="cv2-identity">
                        <h1 className="cv-fs-name">{fullName}</h1>
                        <p className="cv-fs-profession">{jobTitle}</p>
                    </header>

                    <section className="cv2-contact">
                        <h2 className="cv-fs-heading">Contact</h2>
                        <ul className="cv-fs-contact">
                            {contactRows.map((row, i) => (
                                <li key={i}>
                                    {row.icon}
                                    <span>{row.value}</span>
                                </li>
                            ))}
                        </ul>
                    </section>

                    <section className="cv2-side">
                        <h2 className="cv-fs-heading">Profile</h2>
                        <hr />
                        <p className="cv-fs-summary">{sideProfile}</p>
                    </section>
                </>
            )}

            <div className="cv2-main">
                {!isContinuationPage && profile && (
                    <section className="cv2-block">
                        <div className="cv2-blockhead cv-fs-heading">
                            <span className="cv2-badge">
                                <IconPerson />
                            </span>
                            <h2>Profile</h2>
                        </div>
                        <p className="cv2-lead cv-fs-summary">{profile}</p>
                    </section>
                )}

                {education.length > 0 && (
                    <section className="cv2-block" style={{ marginBottom: isContinuationPage ? undefined : '17.6mm' }}>
                        <div className="cv2-blockhead cv-fs-heading">
                            <span className="cv2-badge">
                                <IconCap />
                            </span>
                            <h2>{eduContinued ? 'Education — Suite' : 'Education'}</h2>
                        </div>
                        <div className="cv-fs-education">
                            <Entries items={education} />
                        </div>
                    </section>
                )}

                {experience.length > 0 && (
                    <section className="cv2-block">
                        <div className="cv2-blockhead cv-fs-heading">
                            <span className="cv2-badge">
                                <IconBriefcase />
                            </span>
                            <h2>{expContinued ? 'Experience — Suite' : 'Experience'}</h2>
                        </div>
                        <div className="cv-fs-experience">
                            <Entries items={experience} />
                        </div>
                    </section>
                )}
            </div>
        </article>
    );
};

export default RedNavyTemplate;
